export default "__VITE_ASSET__a7de7c30__"